package meineglasfaser.api.ubl

import com.ionspin.kotlin.bignum.decimal.BigDecimal
import kotlinx.serialization.Contextual
import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
data class UBLTaxCategory(
    @SerialName("id")
    val id: TaxClass,
    @SerialName("name")
    val name: String,
    @Contextual
    @SerialName("percent")
    val percent: BigDecimal,
    @SerialName("tax_scheme_id")
    val taxScheme: TaxScheme,
) {
    enum class TaxClass {
        S,
        Z,
        E,
        G,
        O;
    }

    enum class TaxScheme {
        VAT;
    }
}
